<template>
  <v-app>
    <v-app-bar :elevation="1" :height="80">
      <!-- <template v-slot:prepend>
        <v-app-bar-nav-icon></v-app-bar-nav-icon>
      </template> -->
      <v-app-bar-title>
        <b style="font-size: 42px; font-family: 'Bogart';">DentalJack</b>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <span style="font-size: 24px;">next level zahnzusatzversicherungen</span>
      </v-app-bar-title>
      <v-spacer></v-spacer>
      <v-icon class="mr-4">mdi-lock</v-icon>
    </v-app-bar>
    <div id="content">
      <LoaderOverlay />
      <ErrorOverlay />
      <div class="router-container mt-4">
        <router-view></router-view>
      </div>
    </div>

    <v-footer app>
      <v-col class="text-center">
        <span>&copy; 2023 DentalJack. Alle Rechte vorbehalten.</span>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useBerechnungStore } from "@/stores/berechnung";
import { useGuestStore } from "@/stores/guest";

import LoaderOverlay from "@/components/base/LoaderOverlay.vue";
import ErrorOverlay from "@/components/base/ErrorOverlay.vue";

import BaseCalls from "@/services/BaseCalls";

const berechnungStore = useBerechnungStore();
const guestStore = useGuestStore();

const lastBerechnung = ref(false);

async function getLastBerechnung(guest_id) {
  let berSelect = {};
  berSelect.action = "getLastBerechnung";
  berSelect.ber_guest_id = guest_id;
  console.log("get berechnung " + berSelect.ber_guest_id);
  try {
    const resp = await BaseCalls.postBerechnung(berSelect);
    if (resp.data && resp.data.berechnung) {
      lastBerechnung.value = resp.data.berechnung;
      berechnungStore.setBerechnung(resp.data.berechnung);
      console.log("last berechnung ");
    }
  } catch (err) {
    console.log("error berechnung");
  }
}

async function checkInsertGuest() {
  let guestSelect = {};
  guestSelect.action = "checkInsertGuest";
  try {
    const resp = await BaseCalls.postGuest(guestSelect);
    if (resp.data && resp.data.guest) {
      guestStore.setGuest(resp.data.guest);
      console.log("last guest");
      getLastBerechnung(resp.data.guest.guest_id);
    }
  } catch (err) {
    console.log("error berechnung");
  }
}

onMounted(() => {
  checkInsertGuest();
});
</script>

<style>
#app {
  /* Remove background color if not needed here */
}

#content {
  background-color: #f0f0f0; /* Light gray background */
  display: flex;
  justify-content: center; /* Center the content horizontally */
  padding-top: 90px; /* Space for the fixed header */
  min-height: calc(100vh - 140px); /* Angepasste Höhe wegen Footer */
}

.router-container {
  width: 100%;
  max-width: 1200px; /* Set the maximum width */
  /* Optional: Add padding for better appearance */
  padding: 0 20px;
}

/* Remove margin-top from #content if added elsewhere */
body {
  margin: 0;
}

header {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: white;
  color: black;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

/* Adjust the height of the app bar to accommodate the larger font */
.v-app-bar {
  height: 80px;
}

/* Center the title vertically within the app bar */
.v-app-bar-title {
  display: flex;
  align-items: center;
}

/* Optional: Styles für den Footer */
.v-footer {
  background-color: #fafafa;
  padding: 20px 0;
}

.v-footer .v-col {
  font-size: 14px;
  color: #666;
}
</style>
